import { useMemo } from 'react';

import { localIsoDate } from '@/lib/dates';

import { missingDaysInRange, PRACTITIONER_DECIDED_FORWARD_DAYS } from '../lib/coverage';

import { useAvailabilityRange } from './useAvailabilityRange';

export interface CadenceStatus {
  overdue: boolean;
  missingDays: string[];
  isLoading: boolean;
}

export function useCadenceStatus(practitionerId: string): CadenceStatus {
  const from = localIsoDate(0);
  const to = localIsoDate(PRACTITIONER_DECIDED_FORWARD_DAYS - 1);
  const query = useAvailabilityRange(practitionerId, { from, to });

  return useMemo<CadenceStatus>(() => {
    if (query.isLoading || !query.data) {
      return { overdue: false, missingDays: [], isLoading: true };
    }
    const missing = missingDaysInRange(query.data.rows, from, to);
    return { overdue: missing.length > 0, missingDays: missing, isLoading: false };
  }, [query.isLoading, query.data, from, to]);
}
